/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Save_LabelInputs */

const en_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Settings`)
};

const fr_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les parametres`)
};

const de_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen speichern`)
};

const it_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva impostazioni`)
};

const ru_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните настройки`)
};

const es_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar configuración`)
};

const zh_cn2_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存设置`)
};

const ja_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を保存`)
};

const hi_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स सेव करें`)
};

const pt_pt2_timing_sync_save_label = /** @type {(inputs: Timing_Sync_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar configurações`)
};

/**
* | output |
* | --- |
* | "Save Settings" |
*
* @param {Timing_Sync_Save_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_save_label = /** @type {((inputs?: Timing_Sync_Save_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Save_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_save_label(inputs)
	if (locale === "de") return de_timing_sync_save_label(inputs)
	if (locale === "it") return it_timing_sync_save_label(inputs)
	if (locale === "ru") return ru_timing_sync_save_label(inputs)
	if (locale === "es") return es_timing_sync_save_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_save_label(inputs)
	if (locale === "ja") return ja_timing_sync_save_label(inputs)
	if (locale === "hi") return hi_timing_sync_save_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_save_label(inputs)
	return en_timing_sync_save_label(inputs)
});